import React, { useState } from 'react';
import { JALUR_INFO } from './JalurContext';

export default function LayarPilihJalur({ onPilih }) {
  const [selected, setSelected] = useState(null);

  const handleLanjut = () => {
    if (selected) onPilih(selected);
  };

  return (
    <div className="flex flex-col h-full px-7 pt-12 pb-10 bg-[var(--bg-app)] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{ backgroundImage: 'repeating-linear-gradient(135deg, var(--accent) 0px, var(--accent) 1px, transparent 1px, transparent 18px)' }} />

      <div className="relative z-10 flex-1 flex flex-col">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-[var(--accent)] flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">🎖️</span>
          </div>
          <h1 className="text-[var(--text-primary)] text-2xl mb-2" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600 }}>
            Pilih Jalur Seleksi
          </h1>
          <p className="text-stone-400 text-sm leading-relaxed px-4">
            Instruksi dan fokus latihan akan disesuaikan dengan jalur yang kamu pilih
          </p>
        </div>

        <div className="space-y-4 flex-1">
          {Object.values(JALUR_INFO).map((j) => {
            const isSelected = selected === j.id;
            return (
              <button
                key={j.id}
                onClick={() => setSelected(j.id)}
                className={`w-full text-left p-5 rounded-2xl border-2 transition-all
                  ${isSelected
                    ? 'border-[var(--accent)] bg-[var(--bg-card3)]'
                    : 'border-[var(--border)] bg-[var(--bg-card2)] hover:border-[#4A5538]'}`}
              >
                <div className="flex items-start gap-4">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0
                    ${isSelected ? 'bg-[var(--accent)]' : 'bg-[var(--bg-card3)]'}`}>
                    <span className="text-2xl">{j.icon}</span>
                  </div>
                  <div className="flex-1">
                    <p className={`text-lg font-bold mb-1 ${isSelected ? 'text-[var(--accent)]' : 'text-[var(--text-primary)]'}`}
                       style={{ fontFamily: "'Poppins', sans-serif" }}>
                      {j.label}
                    </p>
                    <p className="text-stone-400 text-xs mb-2">
                      📚 {j.pendidikan}
                    </p>
                    <p className="text-stone-300 text-xs leading-relaxed">
                      {j.fokus}
                    </p>
                  </div>
                  {isSelected && (
                    <span className="text-[var(--accent)] text-xl font-bold">✓</span>
                  )}
                </div>
              </button>
            );
          })}
        </div>

        <div className="bg-[var(--bg-card3)]/60 border border-[var(--border)] rounded-xl p-3 mt-4 mb-5">
          <p className="text-stone-400 text-[11px] leading-relaxed">
            💡 Kamu bisa mengganti jalur kapan saja melalui menu Profil
          </p>
        </div>

        <button
          onClick={handleLanjut}
          disabled={!selected}
          className={`w-full py-3.5 rounded-lg text-sm uppercase font-semibold tracking-wide transition-all
            ${selected
              ? 'bg-[var(--accent)] text-[var(--bg-app)] active:scale-[0.98]'
              : 'bg-[var(--border)] text-stone-500 cursor-not-allowed'}`}
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          {selected ? `Lanjut sebagai ${JALUR_INFO[selected].label} →` : 'Pilih jalur dulu'}
        </button>
      </div>
    </div>
  );
}
